import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const response = await fetch("https://hook.eu2.make.com/t9cwqgt1pjmwbbwig60iq6nnr7hmn54g", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage("Support er blevet informeret om dit problem. Vi vil kontakte dig hurtigst muligt.");
        setEmail("");
      } else {
        setMessage("Der opstod en fejl. Prøv igen senere.");
      }
    } catch (error) {
      setMessage("Der opstod en fejl. Prøv igen senere.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img
            src="/logo.png"
            alt="Din Lønpartner Logo"
            className="login-logo"
          />
          <h1>Glemt adgangskode</h1>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {message && (
            <div className="message" role="alert">
              {message}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div className="input-with-icon">
              <i className="fas fa-envelope"></i>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Indtast din email"
                required
                disabled={isLoading}
              />
            </div>
          </div>

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? (
              <span className="loading-spinner">
                <i className="fas fa-spinner fa-spin"></i>
              </span>
            ) : (
              "Send anmodning"
            )}
          </button>

          <button
            type="button"
            className="back-button"
            onClick={() => navigate("/login")}
            disabled={isLoading}
          >
            Tilbage til login
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword; 